<span
  *ngIf="vendorAddress?.companyName"
  [attr.ariaLabel]="'checkout.viewProviderDetails' | cxTranslate: {companyName: vendorAddress.companyName}"
  class="d-inline-flex flex-row justify-content-start align-items-center"
>
  <span
    class="header eyebrow--s"
    data-cy="tooltip-opener"
  >{{ vendorAddress?.companyName }}</span>
  <dcp-icon-button-tooltip
    title="{{vendorAddress.companyName}}"
    [openOnClick]="true"
    [openOnHover]="false"
    accessibleName="providerDetailsTooltip">
    <div class="content-container body--s"
    >
      {{ getTooltipText() }}
    </div>
  </dcp-icon-button-tooltip>
</span>
